import { Award } from "lucide-react";
import Link from "next/link";
import { cn } from "@/lib/utils";

interface MDECBadgeProps {
  readonly variant?: "hero" | "compact" | "card";
  readonly className?: string;
}

export function MDECBadge({
  variant = "compact",
  className
}: MDECBadgeProps) {
  const badgeContent = (
    <>
      {variant === "hero" && (
        <Link
          href="/blog/anchor-sprint-malaysia-digital-status-mdec/"
          className={cn(
            "group inline-flex items-center gap-2.5 rounded-xl bg-white/90 backdrop-blur-sm px-3 py-1.5 shadow-md border border-gray-100/50 hover:bg-white hover:shadow-lg hover:scale-[1.01] transition-all duration-200 cursor-pointer",
            className
          )}
        >
          <img
            src="/images/mdec-logo.png"
            alt="MDEC Malaysia Digital Status"
            className="h-9 w-auto object-contain group-hover:scale-105 transition-transform duration-200"
          />
          <div className="flex flex-col leading-none">
            <span className="text-xs font-semibold text-gray-800">
              Malaysia Digital
            </span>
            <span className="text-[10px] text-gray-500">
              Certified by MDEC
            </span>
          </div>
        </Link>
      )}

      {variant === "compact" && (
        <span className={cn(
          "inline-flex items-center gap-2 rounded-full border border-primary/20 bg-primary/10 px-4 py-2 text-sm font-semibold text-primary",
          className
        )}>
          <Award className="size-4" aria-hidden />
          Malaysia Digital (MDEC)
        </span>
      )}

      {variant === "card" && (
        <div className={cn(
          "rounded-2xl bg-gradient-to-br from-primary/10 to-primary/5 p-6 text-center shadow-md",
          className
        )}>
          <div className="mx-auto mb-4 flex size-16 items-center justify-center rounded-full bg-primary/20">
            <Award className="size-8 text-primary" aria-hidden />
          </div>
          <h3 className="mb-2 text-sm font-semibold uppercase tracking-[0.2em] text-primary">
            Malaysia Digital Status
          </h3>
          <p className="text-sm text-neutral-muted">
            Certified Malaysia Digital (MDEC) company delivering compliant AI transformation
          </p>
        </div>
      )}
    </>
  );

  return badgeContent;
}
